import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function ProductDetailErrorState() {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 4,
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          color: "#666",
          textAlign: "center",
        }}
      >
        Unable to load product details. Please try again.
      </Typography>
    </Box>
  );
}
